import { render, staticRenderFns } from "./FeatureCards.vue?vue&type=template&id=6dae1ae9&scoped=true&"
import script from "./FeatureCards.vue?vue&type=script&lang=js&"
export * from "./FeatureCards.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCards.vue?vue&type=style&index=0&id=6dae1ae9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dae1ae9",
  null
  
)

export default component.exports